import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBookingState, IFilterBooking } from "./bookingModel";
import {
  createBooking,
  deleteBooking,
  getAllBookings,
  getBookingByID,
  updateBooking,
  ValidateReferalCode,
} from "./services/booking.services";

export const initialFilterBookingState: IFilterBooking = {
  BookingDateFrom: null,
  BookingDateTo: null,
  CheckinDateFrom: null,
  CheckinDateTo: null,
  CheckinTime: "",
  Name: "",
  MobileNo: "",
  EmailID: "",
  Address: "",
  City: "",
  State: "",
  NoOfRooms: 0,
  NoOfPax: 0,
  RoomType: "",
  Source: "",
  Remarks: "",
  ReferalCode: "",
  limit: 10,
  skip: 0,
};

const initialState: IBookingState = {
  loading: false,
  formLoading: false,
  ValidateRefCode: false,
  BookingList: [],
  BookingDetail: {
    ID: 0,
    BookingDate: new Date(),
    CheckinDate: "",
    CheckinTime: "",
    Name: "",
    MobileNo: "",
    EmailID: "",
    Address: "",
    City: "",
    State: "",
    NoOfRooms: 0,
    NoOfPax: 0,
    RoomType: "",
    Source: "",
    Remarks: "",
  },
  BookingID: null,
  FilterBookingDetails: initialFilterBookingState,
};

const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    setBookingID: (state, action: PayloadAction<number | null>) => {
      state.BookingID = action.payload;
    },
    clearBookingID: (state) => {
      state.BookingID = null;
    },
    clearBookingDetails: (state) => {
      state.BookingDetail = initialState.BookingDetail;
      state.BookingID = null;
    },
    setFilterBookingDetails: (state, action: PayloadAction<IFilterBooking>) => {
      state.FilterBookingDetails = action.payload;
    },
    resetFilterBookingDetails: (state) => {
      state.FilterBookingDetails = initialFilterBookingState;
    },
  },
  extraReducers: (builder) => {
    builder
      // getAllBookings
      .addCase(getAllBookings.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllBookings.fulfilled, (state, action) => {
        state.loading = false;
        state.BookingList = action.payload;
      })
      .addCase(getAllBookings.rejected, (state) => {
        state.loading = false;
        state.BookingList = [];
      })
      // getBookingByID
      .addCase(getBookingByID.pending, (state) => {
        state.formLoading = true;
      })
      .addCase(getBookingByID.fulfilled, (state, action) => {
        state.formLoading = false;
        state.BookingDetail = action.payload;
      })
      .addCase(getBookingByID.rejected, (state) => {
        state.formLoading = false;
        state.BookingDetail = initialState.BookingDetail;
      })
      // createBooking
      .addCase(createBooking.pending, (state) => {
        state.formLoading = true;
      })
      .addCase(createBooking.fulfilled, (state) => {
        state.formLoading = false;
      })
      .addCase(createBooking.rejected, (state) => {
        state.formLoading = false;
      })
      // updateBooking
      .addCase(updateBooking.pending, (state) => {
        state.formLoading = true;
      })
      .addCase(updateBooking.fulfilled, (state) => {
        state.formLoading = false;
      })
      .addCase(updateBooking.rejected, (state) => {
        state.formLoading = false;
      })
      // deleteBooking
      .addCase(deleteBooking.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteBooking.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteBooking.rejected, (state) => {
        state.loading = false;
      })
      // Validate Referal code
      .addCase(ValidateReferalCode.pending, (state) => {
        state.ValidateRefCode = true;
      })
      .addCase(ValidateReferalCode.fulfilled, (state) => {
        state.ValidateRefCode = false;
      })
      .addCase(ValidateReferalCode.rejected, (state) => {
        state.ValidateRefCode = false;
      });
  },
});

export const {
  setBookingID,
  clearBookingID,
  clearBookingDetails,
  setFilterBookingDetails,
  resetFilterBookingDetails,
} = bookingSlice.actions;

export default bookingSlice.reducer;
